import { useMemo } from "react";

import type { InlineLexicalInputProps, OfferDefinition } from "./types";
import type { Offer } from "@/api/offerBank";

import { useOfferBlockOffers } from "@/grapesPlugins/email/OfferBlock/hooks";
import { getOfferPreview } from "@/grapesPlugins/email/OfferBlock/offerUtils";

function toOfferDefinition(offer: Offer): OfferDefinition {
  return {
    slug: offer.slug,
    name: offer.name,
    preview: getOfferPreview(offer),
    fallbackCode: offer.static_code,
    isStatic: offer.code_source_type === "static",
  };
}

export function useInlineOffers(
  siteId: string,
): InlineLexicalInputProps["offers"] | undefined {
  const { data } = useOfferBlockOffers(siteId);

  return useMemo(() => {
    const offers = data?.offers;
    if (!offers?.length) return undefined;

    const list = offers.map(toOfferDefinition);
    const bySlug = new Map(list.map((o) => [o.slug, o]));

    return {
      list,
      lookup: (slug: string) => bySlug.get(slug),
    };
  }, [data?.offers]);
}
